import { IAccBienLaiThietLapActionTypes } from "../../action-types/category/IBienLaiThietLapActions";
import { IBienLaiThietLapReducer } from "../../reducer-model/category/IBienLaiThietLapReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IBienLaiThietLapReducer = {
  status: eReducerStatusBase.is_not_initialization,
  bienLaiThietLaps: [],
};
export const bienLaiThietLapReducer = (
  state: IBienLaiThietLapReducer = iniState,
  action: IAccBienLaiThietLapActionTypes
): IBienLaiThietLapReducer => {
  switch (action.type) {
    case "BIEN_LAI_THIET_LAP_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "BIEN_LAI_THIET_LAP_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        bienLaiThietLaps: action.payload,
      };
    case "BIEN_LAI_THIET_LAP_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "BIEN_LAI_THIET_LAP_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "BIEN_LAI_THIET_LAP_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "BIEN_LAI_THIET_LAP_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "BIEN_LAI_THIET_LAP_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "BIEN_LAI_THIET_LAP_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "BIEN_LAI_THIET_LAP_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "BIEN_LAI_THIET_LAP_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        bienLaiThietLapEditing: action.payload,
      };
    case "BIEN_LAI_THIET_LAP_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        bienLaiThietLapEditing: undefined,
      };
    default:
      return state;
  }
};
